import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CommonService } from '../../services/commen/commen.services';

@Component({
  selector: 'app-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss']
})
export class EmptyPageComponent implements OnInit, OnChanges {
  @Output() addItem = new EventEmitter<any>();
  @Input() label: any;
  @Input() isSearch: any;
  @Input() noDataSearchlabel: any = 'No matches found for your search.';
  constructor(private commonService: CommonService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.isSearch) {
      this.commonService.onSvgLoad('../../../../assets/comman/empty-data-search-icon.svg', 'searchEmptyIcon');
    } else {
      this.commonService.onSvgLoad('../../../../assets/comman/empty-data-icon.svg', 'emptyIcon');
    }
  }

}
